import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AddResourceForm } from '@/areas/manufacturing-templates/Resources/ResourceCreation/AddResourceForm';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { PageLayout } from '@/shared/ui/PageLayout';

export const Route = createFileRoute('/_authenticated/manufacturing/resources/create')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <PageLayout layout="full-width">
            <AddResourceForm />
        </PageLayout>
    );
}
